import React, { useState } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";

type PropsType = {
  onIndividual: () => void;
  onBusiness: () => void;
};
const IndividualBusinessToggle: React.FC<PropsType> = ({
  onIndividual,
  onBusiness,
}) => {
  const { t } = useTranslation("onboarding-auth");
  const [selected, setSelected] = useState<"individual" | "business">(
    "individual"
  );
  return (
    <div className="ibt-container">
      <button
        type="button"
        className={`ibt-option ${selected === "individual" ? "active" : ""}`}
        onClick={() => {
          setSelected("individual");
          onIndividual();
        }}
      >
        {t("individual")}
      </button>
      <button
        type="button"
        className={`ibt-option ${selected === "business" ? "active" : ""}`}
        onClick={() => {
          setSelected("business");
          onBusiness();
        }}
      >
        {t("business")}
      </button>
    </div>
  );
};

export default IndividualBusinessToggle;
